import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import TeamMemberViewPane, { ITeamMemberViewPaneParams } from '../../components/team-members/view/TeamMemberViewPane'
import { fetchTeamMember } from '../../state/actions/team_members'
import { getOrganization } from '../../state/selectors'
import { IStoreState, IMemberSearchObject } from '../../types'
import { moveToArchive, sendResetPasswordLink, sendInvite } from '../../state/actions/team_members/index'
import { recoverPassword } from 'src/state/actions/auth'

const mapStateToProps = (state: IStoreState, { match }: any): any => {
  const teamMember = state.teamMember.items[match.params.id]
  const organization = teamMember && getOrganization(teamMember.organizationId, state)

  return {
    teamMember,
    organizationName: (organization && organization.name) || '',
    isFetching: state.teamMember.isFetching,
    error: state.teamMember.error
  }
}

const mapDispatchToProps = (dispatch: any, props: RouteComponentProps<ITeamMemberViewPaneParams>) => {
  return {
    fetchTeamMember: () => dispatch(fetchTeamMember(props.match.params.id)),
    onArchiveClick: (teamMember: IMemberSearchObject) => {
      return dispatch(moveToArchive(teamMember))
    },
    onResetClick: (teamMember: IMemberSearchObject) => {
      return dispatch(recoverPassword(teamMember.email))
    },
    onSendInviteClick: (teamMember: IMemberSearchObject) => {
      return dispatch(sendInvite(teamMember))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberViewPane)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberViewPane.ts